import { useMutation } from '@tanstack/react-query'
import { useEffect, useRef } from 'react'

import { authAPI } from '@/api/new-api'
import { toastFactory } from '@/factories'
import { downloadHref, getApiErrorMessage } from '@/utils'

import { GetChecklistsRequest } from './get-checklists'

export interface DownloadChecklistsRequest extends GetChecklistsRequest {
  fileName: string
}

export const exportChecklists = async (data: GetChecklistsRequest) => {
  const { buildingId, ...params } = data

  const response = await authAPI.get<Blob>(`/checklist-unified/export/${buildingId}`, {
    params,
    responseType: 'blob',
  })
  return response.data
}

export const useExportChecklists = () => {
  const objectUrlRef = useRef<string | null>(null)

  const mutation = useMutation({
    mutationFn: async ({ fileName, ...rest }: DownloadChecklistsRequest) => {
      const blob = await exportChecklists(rest)
      if (objectUrlRef.current) URL.revokeObjectURL(objectUrlRef.current)
      objectUrlRef.current = URL.createObjectURL(blob)
      downloadHref(objectUrlRef.current, fileName)
      return objectUrlRef.current
    },
    onError: (error) => {
      toastFactory.error(getApiErrorMessage(error))
    },
  })

  // Note: Clean up the URL object when the hook unmounts
  useEffect(() => {
    return () => {
      if (objectUrlRef.current) URL.revokeObjectURL(objectUrlRef.current)
    }
  }, [])

  return mutation
}
